import {
  RuntimeVariablesInputType,
  RuntimeVariablesSchema,
  RuntimeVariablesType,
} from "@reflag/shared/schemas/runtimeVariablesSchema";

declare global {
  interface Window {
    env: RuntimeVariablesInputType | RuntimeVariablesType;
  }
}

// `window.env` is set when served by the Node.js server
// `import.meta.env` is set while development by Webpack/CRA
window.env = window?.env ?? import.meta.env ?? {};
const parsed = RuntimeVariablesSchema.parse(window.env);

window.env = parsed;

export const {
  ENVIRONMENT,
  SETUP_DEMO_DATA,
  GIT_COMMIT,
  CLERK_PUBLISHABLE_KEY,
  API_URL,
  SENTRY_DSN,
  REFLAG_PUBLISHABLE_KEY,
  INTERCOM_APP_ID,
} = parsed;
